import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import UseCaseDetailsFrame from 'src/components/use-case-details-frame'
import PillButton from 'src/components/pill-button'
import BrowserContainer from 'src/components/browser-container'
import TextButton from 'src/components/text-button'
import TapAnimation from 'src/components/tap-animation'
import content1Src from 'src/assets/use-case-2-content-1.png'
import content2Src from 'src/assets/use-case-2-content-2.png'
import content3Src from 'src/assets/use-case-2-content-3.png'
import content4Src from 'src/assets/use-case-2-content-4.png'

export class UseCase2Frame1 extends Component {
  static propTypes = {
    className: PropTypes.string,
    useCase: PropTypes.object.isRequired,
    back: PropTypes.func.isRequired,
  }

  static defaultProps = {
    className: '',
  }

  state = {
    contentId: 'content-1',
    shouldTap1A: false,
    shouldTap1B: false,
    shouldTap3: false,
    onTapComplete: () => {},
  }

  get className() {
    const { className } = this.props
    return c('im-use-case-2-frame-1', className)
  }

  render() {
    const { className } = this
    const { useCase, back } = this.props
    const { contentId, shouldTap1A, shouldTap1B, shouldTap3, onTapComplete } = this.state
    const { content1, content2, content3, content4 } = useCase
    return (
      <UseCaseDetailsFrame className={className} back={back} useCase={useCase} type="browser">
        <section className={c('content content-1', contentId === 'content-1' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h3>{content1.copy1}</h3>
              <h2>{content1.copy2}</h2>
            </section>
            <section className="pill-buttons">
              <PillButton
                onClick={() => {
                  this.setState({
                    shouldTap1A: true,
                    onTapComplete: () => {
                      this.setState({ shouldTap1A: false, contentId: 'content-2' })
                    },
                  })
                }}>
                {content1.button1}
              </PillButton>
              <PillButton
                onClick={() => {
                  this.setState({
                    shouldTap1B: true,
                    onTapComplete: () => {
                      this.setState({ shouldTap1B: false, contentId: 'content-3' })
                    },
                  })
                }}>
                {content1.button2}
              </PillButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={content1Src}>
              <TapAnimation className="tap-1-a" shouldTap={shouldTap1A} onTapComplete={onTapComplete} />
              <TapAnimation className="tap-1-b" shouldTap={shouldTap1B} onTapComplete={onTapComplete} />
            </BrowserContainer>
          </section>
        </section>
        <section className={c('content content-2', contentId === 'content-2' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content2.copy1}</h2>
              <p>{content2.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content2.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={content2Src} />
          </section>
        </section>
        <section className={c('content content-3', contentId === 'content-3' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content3.copy1}</h2>
              <p>{content3.copy2}</p>
            </section>
            <section className="pill-buttons with-text-buttons">
              <PillButton
                onClick={() => {
                  this.setState({
                    shouldTap3: true,
                    onTapComplete: () => {
                      this.setState({ shouldTap3: false, contentId: 'content-4' })
                    },
                  })
                }}>
                {content3.button1}
              </PillButton>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content3.button2}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={content3Src}>
              <TapAnimation className="tap-3" shouldTap={shouldTap3} onTapComplete={onTapComplete} />
            </BrowserContainer>
          </section>
        </section>
        <section className={c('content content-4', contentId === 'content-4' && 'selected')}>
          <section className="choices-container">
            <section className="copy">
              <h2>{content4.copy1}</h2>
              <p>{content4.copy2}</p>
            </section>
            <section className="text-buttons">
              <TextButton onClick={() => this.setState({ contentId: 'content-1' })}>
                {content4.button1}
              </TextButton>
            </section>
          </section>
          <section className="device-container">
            <BrowserContainer src={content4Src} />
          </section>
        </section>
      </UseCaseDetailsFrame>
    )
  }
}

export default UseCase2Frame1
